import _ from 'lodash';

// this function will return a copy of formParams
// with all values trimmed.
// if the trimmed value results in an empty string,
// the value will be replaced with null
// eslint-disable-next-line import/prefer-default-export
export function trimUserInput(formParams) {
  const newValues = JSON.parse(JSON.stringify(formParams));

  _.forEach(newValues, (value, key) => {
    if (typeof value === 'string') {
      newValues[key] = value.trim();

      if (newValues[key] === '') {
        newValues[key] = null;
      }
    }
  });

  return newValues;
}



// WEBPACK FOOTER //
// ./src/utils/formHelpers.js